import { Component } from 'react';
import PropTypes from 'prop-types';

import {
	getStyleValue,
	raisedButtonRowStyles,
	ucfirst,
	getStatusFromValue,
} from '../Helpers/Helpers';

import { Button } from '@mui/material';

class ActionInput extends Component {
	constructor(props) {
		super(props);

		this.state = {
			anchorEl: null,
			selected: props.selected || '',
			status: getStatusFromValue(props.selected) || '',
			activeColor: props.activeColor || getStyleValue('color-primary'),
			defaultSelected: props.defaultSelected || '',
		};
	}
	handleSetValue(event) {
		const selected = event.currentTarget.getAttribute('data-id');
		if (selected === this.state.selected) {
			// Deselect
			this.setState({
				selected: '',
				status: '',
				defaultSelected: this.props.defaultSelected,
			});
		} else {
			this.setState({
				selected,
				status: getStatusFromValue(selected),
				defaultSelected: null,
			});
		}
	}
	setColor(id, activeColor, defaultColor) {
		let color = defaultColor;

		// If there is no selection made yet
		if (!this.state.selected) {
			// Set default selected color
			if (this.state.defaultSelected === id) {
				// Don't overwrite if the active color is white
				if (activeColor !== getStyleValue('color-white')) {
					color = getStyleValue('color-default');
				}
			}
		}

		// Set color of active element
		if (this.state.selected === id) {
			color = activeColor;
		}

		return color;
	}

	button(label, position) {
		const buttonStyles = raisedButtonRowStyles();
		position = ucfirst(position);

		return (
			<Button
				variant="contained"
				data-id={label}
				onClick={this.handleSetValue.bind(this)}
				style={{
					...buttonStyles[`styleButton${position}`],
					...buttonStyles[`style${position}`],
					color: this.setColor(label, getStyleValue('color-white'), getStyleValue('color-text')),
					backgroundColor: this.setColor(label, this.state.activeColor, getStyleValue('color-grey')),
				}}
			>
				{label}
			</Button>
		);
	}

	render() {
		const { defaultSelected, ...filteredProps } = this.props; // eslint-disable-line no-unused-vars
		return (
			<div {...filteredProps}>
				{this.button(this.props.t.action_replacement, 'first')}
				{this.button(this.props.t.action_overhaul, '')}
				{this.button(this.props.t.action_recommendation, 'last')}
				<input name={this.props.name} type="hidden" value={this.state.status} data-notrequired={this.props['data-notrequired']} />
			</div>
		);
	}
}

ActionInput.propTypes = {
	activeColor: PropTypes.string,
	defaultSelected: PropTypes.string,
	name: PropTypes.string.isRequired,
};

export default ActionInput;
